import DgTreeWithMenu from './src/main.vue'
// 为组件提供 install 安装方法，供按需引入
DgTreeWithMenu.install = function (Vue) {
  Vue.component(DgTreeWithMenu.name, DgTreeWithMenu)
}
export default DgTreeWithMenu

export { DgTreeWithMenu }